import axios from "axios";
import {
  SETTINGS_PUNCH_LIST_PRIORITY_CLEAR_SNACKBAR,
  SETTINGS_PUNCH_LIST_PRIORITY_ERROR,
  SETTINGS_DELETE_PUNCH_LIST_PRIORITY_SUCCESS,
  SETTINGS_GET_PUNCH_LIST_PRIORITY_LOADING,
  SETTINGS_ADD_PUNCH_LIST_PRIORITY_ERROR,
  SETTINGS_ADD_PUNCH_LIST_PRIORITY_SUCCESS,
  SETTINGS_ADD_PUNCH_LIST_PRIORITY,
  SETTINGS_GET_PUNCH_LIST_PRIORITY,
} from "../constants/types";
import queryString from "query-string";

// import { bulkUploadFiles } from "./documentsActions";

import { server_url } from "../constants/types";
import request from "config/api";

export const fetchPunchListPriority = (params = {}) => {
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: SETTINGS_GET_PUNCH_LIST_PRIORITY_LOADING,
        payload: {
          loading: true,
        },
      });
      const newParams = {
        PageNumber: params.page ? params.page + 1 : 1,
        PageSize: params.pageSize ? params.pageSize : 10,
      };
      const queryParams = queryString.stringify(newParams);

      request({
        url: `${server_url}/PunchListPriority`,
        method: "GET",
      })
        .then((response) => {
          dispatch({
            type: SETTINGS_GET_PUNCH_LIST_PRIORITY,
            payload: {
              punchListPriority: response.data,
              totalCount: response.data.length,
              loading: false,
            },
          });
          resolve();
        })
        .catch((e) => {
          dispatch({
            type: SETTINGS_PUNCH_LIST_PRIORITY_ERROR,
            payload: {
              status: "error",
              text: "Error occured during getting all PunchListPriority.",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        });
    });
  };
};

export const addUpdatePunchListPriority = ({ formData, onSuccess, payload }) => {
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: SETTINGS_ADD_PUNCH_LIST_PRIORITY,
        payload: {
          loading: true,
        },
      });

      let data = {
        ...formData,
      };

      request({
        method: formData.punchListPriorityId ? "PUT" : "POST",
        url: `${server_url}/PunchListPriority${
          formData.punchListPriorityId ? `/${formData.punchListPriorityId}` : ""
        }`,
        body: { ...data },
      })
        .then(async (response) => {
          onSuccess();

          dispatch({
            type: SETTINGS_ADD_PUNCH_LIST_PRIORITY_SUCCESS,
            payload: {
              response: response.data,
              status: "success",
              text: formData.punchListPriorityId
                ? "PunchListPriority updated Successfully"
                : "PunchListPriority Created Successfully",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        })
        .catch((e) => {
          dispatch({
            type: SETTINGS_ADD_PUNCH_LIST_PRIORITY_ERROR,
            payload: {
              text: "Error occurred during creating punchListPriority data.",
              status: "error",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        });
    });
  };
};

export const punchListPriorityDelete = ({
    punchListPriorityId,
  pageModel,
  onSuccess = () => {},
  showSnackbar = true,
}) => {
  console.log("Check the PunchListPriorityDelete Action", punchListPriorityId);
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: SETTINGS_GET_PUNCH_LIST_PRIORITY_LOADING,
        payload: {
          loading: true,
        },
      });
      request({
        url: `${server_url}/PunchListPriority/${punchListPriorityId}`,
        method: "DELETE",
      })
        .then((response) => {
          dispatch(fetchPunchListPriority({ ...pageModel }));
          onSuccess();

          dispatch({
            type: SETTINGS_DELETE_PUNCH_LIST_PRIORITY_SUCCESS,
            payload: {
              response: response.data,
              status: "success",
              text: "punchListPriority Deleted Successfully",
              loading: false,
              showSnackbar: true,
            },
          });

          resolve();
        })
        .catch((e) => {
          dispatch({
            type: SETTINGS_PUNCH_LIST_PRIORITY_ERROR,
            payload: {
              text: "Error occurred during deleting punchListPriority data.",
              status: "error",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        });
    });
  };
};

export const punchListPriorityClearShowSnackbar = () => {
  return (dispatch, getState) => {
    dispatch({
      type: SETTINGS_PUNCH_LIST_PRIORITY_CLEAR_SNACKBAR,
    });
  };
};
